module.exports = require("core-js/library/fn/object/entries");


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/core-js/object/entries.js
// module id = 891
// module chunks = 2